import { DateTime } from 'luxon'

import { getResource } from '@/shared/constants/resources'
import type { Blocker, TimeBlocker } from '@/types/blocker'

/** Texto curto para o card (sem HTML). */
export const getBlockHintText = (blocker: Blocker | TimeBlocker): string => {
  if (blocker.type === 'time') {
    const until = DateTime.fromISO(blocker.until)
    const formatted = until.isValid
      ? until.toFormat("HH:mm dd/MM/yyyy")
      : blocker.until

    return blocker.message
      ? blocker.message.replace('{until}', formatted)
      : `Disponível às ${formatted}`
  }

  if (blocker.type === 'resource') {
    if (blocker.condition === 'blockRedo') {
      return 'Você já completou este nível'
    }

    const resource = getResource(blocker.resource.type)
    const name =
      blocker.resource.name || resource.humanName.singular

    if (blocker.message) {
      return blocker.message.replace('{name}', name).replace(/<[^>]+>/g, '')
    }

    return `Conclua ${resource.humanName.singular.toLowerCase()} ${name}`
  }

  return 'Complete os requisitos para liberar'
}

/** Textos curtos para o card (sem HTML), um por condição não atendida. */
export const getBlockHintTexts = (
  blockers: (Blocker | TimeBlocker)[]
): string[] => {
  const hints = blockers.map(getBlockHintText)

  return Array.from(new Set(hints))
}
